import React from "react";
import '../styles/projectcard.css'
const ProjectCard = ({  project }) => {
  // const imagePath = `server/uploads/${project.imageName}`
  // console.log(project);
  return (
    <div className="project-card">

      <div className="card-top">
      <img src={require(`../../../server/uploads/${project.imageName}`)} alt="" className="project-image"/>

      </div>

      <div className="card-bottom">
      <a href={project.link}  rel="noreferrer" className="project-name" target="_blank">
      {project.name}
      </a>

      <p className="project-about">{project.about}</p>

      
      </div>
      </div>
  );
};

export default ProjectCard;
